import React from 'react';
import {
    Redirect,
    Route
} from "react-router-dom";
import Authentication from "./Authentication";

function PrivateRoute({component: Component, ...rest}) {
    let authentication = new Authentication();
    const isLoggedIn = authentication.isLoggedIn();
    return (
        <Route
            {...rest}
            render={(props) => isLoggedIn
                ? <Component {...props} />
                : <Redirect to={{pathname: '/', state: {from: props.location}}}/>}
        />
    )
}

function AdminPrivateRoute({component: Component, ...rest}) {
    let authentication = new Authentication();
    const isLoggedIn = authentication.isLoggedIn();
    const isAdmin = authentication.isAdmin();
    return (
        <Route
            {...rest}
            render={(props) => isLoggedIn && isAdmin
                ? <Component {...props} />
                : <Redirect to={{pathname: '/', state: {from: props.location}}}/>}
        />
    )
}

export {PrivateRoute, AdminPrivateRoute}
